module.exports = __webpack_public_path__ + "img/logo-two-letters-green.7cc17271.svg";